import { render, staticRenderFns } from "./DispensaImportado.vue?vue&type=template&id=23af0596&"
import script from "./DispensaImportado.vue?vue&type=script&lang=js&"
export * from "./DispensaImportado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports